/**
 * Created by sswaminathan on 1/27/22
 * File: StatusBar
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Body, Button, useModal } from '@panwds/react-ui'
import { CircleCheckIcon, ExclamationCircleIcon } from '@panwds/icons'
import { startCase } from 'lodash'
/**
 *   TODO: Brief what is this component/class do
 */
import { useMemo, useState } from 'react'
import {
  BUTTON_COPY_ERROR,
  LICENSE_STATUS_LABEL_COMPLETE, LICENSE_STATUS_LABEL_COMPLETE_PERCENT,
  LICENSE_STATUS_LABEL_ERROR, LICENSE_STATUS_LABEL_ERROR_PERCENT,
} from '../../../constants/LabelConstants'
import InstanceDetail from '../InstanceDetailModal'

const StatusBar = ({ progress, instanceData }) => {

  const { openModal } = useModal(InstanceDetail)
  const [showProgress, setShowProgress] = useState(!(progress === 0 || progress === 100))

  const copyError = () => {
    openModal({
      data: instanceData[0]
    })
  }

  useMemo(() => {
    setShowProgress((prev) => {
      return !(progress === 0 || progress === 100)
    })
  }, [progress])

  const getStatus = (value) => {
    switch (value) {
      case LICENSE_STATUS_LABEL_COMPLETE_PERCENT:
        return (
          <span className={'tw-flex tw-flex-row tw-items-center tw-gap-1 tw-h-full'}>
            <CircleCheckIcon size='sm' className='cm-text-green-400' />
            {LICENSE_STATUS_LABEL_COMPLETE}
          </span>
        )
      case LICENSE_STATUS_LABEL_ERROR_PERCENT:
        return <>
          <span className={'tw-flex tw-flex-row tw-items-center tw-gap-1 tw-h-full'}>
            <ExclamationCircleIcon size='sm' className='cm-text-red-500' />
            {LICENSE_STATUS_LABEL_ERROR}
          </span>
          <Button
            size='sm'
            appearance="primary"
            onClick={copyError}>{BUTTON_COPY_ERROR}</Button>
        </>
      default:
        return
    }
  }

  return <>
    {showProgress && (
      <div className='tw-flex-col tw-flex' style={{ width: '100%' }}>
        {instanceData.length && <Body size='sm' addClassName='tw-mb-1'>{startCase(instanceData[0].provisioning_status)}</Body>}
        <div id="myProgress">
          <div id="myBar" style={{ width: progress }} />
        </div>
      </div>
    )}
    {!showProgress && (
      <div className="tw-relative tw-flex tw-h-full tw-truncate">
        <Body addClassName='tw-truncate'>{getStatus(progress)}</Body>
      </div>
    )}
  </>
}

StatusBar.propTypes = {}
export default StatusBar
